export enum FilterType {
	Store = "store",
	Product = "product",
	Category = "category",
	Date = "start",
}
